import { debounce } from 'lodash';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomIcon } from '~components/index';
import InputLabel from '../InputLabel/InputLabel';
import '../inputs.scss';

interface Props extends CommonInputProps {
  type?: 'text' | 'number' | 'date' | 'datetime-local' | 'password';
  min?: string;
  step?: string;
  iconName?: IconName;
  defaultValue?: string | number;
  max?: string;
  hookOnChange?: (value: string) => void;
  onInputChange?: (value: string) => void;
}

const Input = ({
  type = 'text',
  name,
  label,
  placeholder,
  step,
  labelHelper,
  iconName,
  defaultValue,
  disabled = false,
  required = false,
  readOnly = false,
  design = 'col-12',
  hookError,
  min,
  max,
  onInputChange = () => {},
  hookOnChange = () => {},
  onFocus = () => {},
  onBlur = () => {}
}: Props) => {
  const { t } = useTranslation();
  const debouncedSetValue = debounce((value: string) => {
    hookOnChange(value);
    onInputChange(value);
  }, 200);

  return (
    <div className={`customInput ${design}`}>
      {label && (
        <InputLabel
          helper={labelHelper}
          name={name}
          text={label}
          required={required}
        />
      )}
      <div
        className={`customInput_container ${
          disabled ? 'customInput_disabled' : ''
        }`}
      >
        {iconName && (
          <CustomIcon
            className="customInput_icon"
            name={iconName}
            color="var(--green-light)"
          />
        )}
        <input
          type={type}
          id={name}
          min={min}
          max={max}
          step={step}
          placeholder={placeholder && t(placeholder)}
          disabled={disabled}
          readOnly={readOnly}
          defaultValue={defaultValue}
          onChange={(e) => {
            const value = e.target.value;
            debouncedSetValue(value);
          }}
          onWheel={(e) => {
            (e.target as HTMLElement).blur();
            e.stopPropagation();
          }}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      </div>
      {hookError?.message && (
        <p className="customInput_error">{t(hookError?.message)}</p>
      )}
    </div>
  );
};

const MemoizeInput = memo(Input);
export default MemoizeInput;
